<template>
    <div class="producttype-sawline-details-page">
        <div class="actions">
            <ui5-button @click="back()">
                {{
                    trans(
                        'pages.producttype_sawline_details.back_to_product_types'
                    )
                }}
            </ui5-button>
            <ui5-button @click="edit()">
                {{ trans('pages.producttype_sawline_details.modify') }}
            </ui5-button>
        </div>
        <!--<pre>{{ conditionFilters }}</pre>-->
        <spinner-text
            class="ajax"
            v-if="loading"
        >
            &nbsp;{{ trans('pages.producttype_sawline_details.loading') }}
        </spinner-text>

        <template v-else-if="productType">
            <h1>{{ productType.label }} (#{{ productType.producttypeId }})</h1>
            <div class="condition-filter-container">
                <ui5-label for="conditionFilter">
                    {{
                        trans(
                            'pages.producttype_sawline_details.filter_by_saw_conditions'
                        )
                    }}
                </ui5-label>
                <ui5-multi-combobox @selection-change="conditionFilterChange">
                    <ui5-mcb-item
                        :selected="conditionFilters.includes(condition)"
                        :text="
                            getDatafieldLabel(
                                productType.dataFields[condition.datafield]
                            ) +
                            ' ' +
                            condition.compare +
                            ' ' +
                            condition.cmpValue
                        "
                        v-for="(
                            condition, conditionIndex
                        ) in productType.allConditions"
                        :key="conditionIndex"
                    ></ui5-mcb-item>
                </ui5-multi-combobox>
            </div>
            <div class="items">
                <div
                    class="item"
                    v-for="rule in productType.rules"
                    v-show="shouldShowSawline(rule)"
                >
                    <div class="description">
                        <span class="title">{{ rule.externalName }}</span>
                    </div>
                    <div class="profile-description">
                        <span class="value">{{ rule.profileDescription }}</span>
                    </div>
                    <div class="calculation">{{ renderRule(rule) }}</div>
                    <div
                        class="conditions"
                        v-if="rule.conditions"
                    >
                        <div class="title">
                            {{
                                trans(
                                    'pages.producttype_sawline_details.conditions'
                                )
                            }}
                        </div>
                        <div
                            class="condition"
                            v-for="condition in rule.conditions"
                        >
                            {{ condition.datafieldName }}
                            {{ condition.compare }} {{ condition.value }}
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import SpinnerText from '../components/loader/SpinnerText';
import productApi from '../api/product';
import {
    isMatchingCondition,
    getDatafieldLabel,
} from '../helpers/sawline-common';
import localization from '../mixins/localization';

export default {
    components: { SpinnerText },
    mixins: [localization],
    props: {},
    mounted() {
        this.id = this.$route.params.id;
        this.loading = true;
        productApi
            .rules(this.id)
            .then((response) => {
                this.productType = response.data.data;
            })
            .finally(() => {
                this.loading = false;
            });
    },
    data() {
        return {
            id: null,
            loading: false,
            productType: null,
            conditionFilters: [],
        };
    },
    methods: {
        shouldShowSawline(sawline) {
            const filteredConditions = this.productType.allConditions.filter(
                (x) => this.conditionFilters.includes(x.ID)
            );

            const sawlineConditions = Object.keys(sawline.conditions || []).map(
                (x) => {
                    return this.productType.allConditions.find((y) => {
                        return y.ID == x;
                    });
                }
            );

            if (!filteredConditions.length) {
                return true;
            }

            return isMatchingCondition(filteredConditions, sawlineConditions);
        },
        conditionFilterChange(event) {
            this.conditionFilters = event.detail.items.map((selectedItem) => {
                const parent = selectedItem.parentElement;
                const index = Array.prototype.indexOf.call(
                    parent.children,
                    selectedItem
                );
                const condition = this.productType.allConditions[index];
                return condition.ID;
            });
        },
        getDatafieldLabel,
        edit() {
            this.$router.push('/producttypesawlinesedit/' + this.id);
        },
        back() {
            this.$router.push('/settingsProducttypes');
        },
        renderRule(rule) {
            const externalName = rule.externalName;
            const unit = rule.unit;
            const value = rule.constant;
            switch (rule.addition) {
                case 0:
                    return externalName + ' ' + unit;
                case 1:
                    return externalName + ' + ' + value + ' ' + unit;
                case 2:
                    return externalName + ' - ' + value + ' ' + unit;
                case 3:
                    return externalName + ' * ' + value + ' ' + unit;
                case 4:
                    return externalName + ' / ' + value + ' ' + unit;
                case 5:
                    return (
                        this.trans(
                            'pages.producttype_sawline_details.constant'
                        ) +
                        ' ' +
                        value +
                        ' ' +
                        unit
                    );
                case 6:
                    return (
                        externalName +
                        this.trans(
                            'pages.producttype_sawline_details.increment'
                        )
                    );
            }
        },
    },
    computed: {},
    watch: {},
};
</script>
